import type { StateData } from '@/lib/become-an-agent-types';

const ANCHOR_VARIANTS = [
    (s: string) => `Become a travel agent in ${s}`,
    (s: string) => `${s} travel agent guide`,
    (s: string) => `Joining a host agency in ${s}`,
    (s: string) => `Travel agent licensing in ${s}`,
    (s: string) => `Travel agent careers in ${s}`,
];

export function CrossStateLinks({
    current: _current,
    neighbors,
}: {
    current: StateData;
    neighbors: Array<{ slug: string; state: string }>;
}) {
    return (
        <section className="bg-[#fdfaf3] border-t border-[#0b2222]/10">
            <div className="mx-auto max-w-6xl px-6 py-12 sm:py-16">
                {neighbors.length > 0 && (
                    <>
                        <div className="lux-caps lux-caps-sm mb-4 text-[#0b2222]/60">
                            Becoming a travel agent in nearby states
                        </div>
                        <div className="flex flex-wrap gap-3">
                            {neighbors.map((n, i) => {
                                const anchor = ANCHOR_VARIANTS[i % ANCHOR_VARIANTS.length](n.state);
                                return (
                                    <a
                                        key={n.slug}
                                        href={`/become-an-agent/${n.slug}`}
                                        className="rounded-sm border border-[#0b2222]/20 bg-white px-3 py-1.5 text-sm text-[#0b2222] transition hover:border-[#0b2222]/40 hover:bg-[#0b2222]/5"
                                    >
                                        {anchor}
                                    </a>
                                );
                            })}
                        </div>
                    </>
                )}

                <a
                    href="/travel-agent-licensing-by-state"
                    className={`lux-caps lux-caps-sm inline-flex items-center gap-2 text-[#0b2222]/70 transition-colors hover:text-[#0b2222] ${
                        neighbors.length > 0 ? 'mt-8' : ''
                    }`}
                >
                    See travel agent licensing across all 50 states{' '}
                    <span aria-hidden="true">&rarr;</span>
                </a>
            </div>
        </section>
    );
}
